import React, { FunctionComponent } from 'react';

import {
  PublishingSource,
  TimelineEntry,
  User,
} from '../../../../../types/__generated__';

import timelineStyles from '../../Timeline.scss';

interface OwnerNameProps {
  publishingSource: TimelineEntry['publishingSource'];
  name: User['name'];
}

export const OwnerName: FunctionComponent<OwnerNameProps> = ({
  publishingSource,
  name,
}) => {
  if (!name) return null;

  function getOwnerName() {
    switch (publishingSource) {
      case PublishingSource.Strava:
        return (
          <>
            <strong>{name}</strong> via <strong>Strava</strong>
          </>
        );
      case PublishingSource.Fitbit:
        return (
          <>
            <strong>{name}</strong> via <strong>Fitbit</strong>
          </>
        );
      default:
        return name;
    }
  }

  return <h2 className={timelineStyles.title}>{getOwnerName()}</h2>;
};
